import { render, staticRenderFns } from "./CcfDashboard.vue?vue&type=template&id=159afc72&"
import script from "./CcfDashboard.vue?vue&type=script&lang=js&"
export * from "./CcfDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports